import React from "react"
import { CaseStudyTemplate } from "./CaseStudyTemplate"

export default function PalmSuccessCaseStudy() {
  return (
    <CaseStudyTemplate
      backToAnchorId="selected-work-palm-success"
      eyebrow="Selected work"
      tag="Brand Identity"
      title="Palm Success — Identity System for Growth"
      summary="A bold, premium identity built for consistency across social, print, and web—so the brand feels recognizable, professional, and ready to scale."
      image="/Palm_Sucess.png"
      imageAlt="Palm Success brand identity"
      sections={[
        {
          title: "The brief",
          body: "Design an identity that feels confident and modern—something that can live on everything from social posts to documents while still feeling premium.",
        },
        {
          title: "The system",
          body: "A cohesive identity direction: logo, visual rules, and repeatable assets. The emphasis was consistency—so every touchpoint looks like the same brand.",
        },
        {
          title: "What changed",
          body: "The brand now has a clear, reusable visual language that improves recognition and makes day-to-day marketing faster and cleaner.",
        },
      ]}
      tech={["Adobe Illustrator", "Adobe Photoshop", "Brand Guidelines", "Mockups"]}
      results={[
        "Consistent visual language",
        "Premium brand feel",
        "Social-ready assets",
        "Print-ready outputs",
      ]}
    />
  )
}

